import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectSingle } from '../../../components/Selects/SelectSingle';
import { useSkillCategoriesQuery } from '../../../__generated__/graphql';

type Props = {
  value: string | null;
  onChange: (value: string | null) => void;
  className?: string;
};

export const SkillCategoryFilter: React.FC<Props> = ({
  value,
  onChange,
  className,
}) => {
  const { t } = useTranslation();
  const { data, loading } = useSkillCategoriesQuery();

  const options = useMemo(
    () =>
      (data?.skillCategories ?? [])
        .slice()
        .sort((a, b) => a.Name.localeCompare(b.Name))
        .map((c) => ({ value: c.Id, label: c.Name })),
    [data],
  );

  useEffect(() => {
    if (loading || !data || !value) return;
    if (!options.some((o) => o.value === value)) {
      onChange(null);
    }
  }, [loading, data, value, options, onChange]);

  return (
    <SelectSingle
      value={value}
      options={options}
      onChange={onChange}
      placeholder={t('skills.category.filterPlaceholder')}
      heightMode="normal"
      className={className}
    />
  );
};
